import {
  ASIProducts,
  initialASIProduct,
  asiColumns, asiColumnsV2,
  columnToPropertyMapping,
  productBundleV2,
  productBundle,
  initialproductBundle,
  columnToproductBundleMapping,
} from './asi.model';
import { throwError } from 'rxjs';
import { environment } from '../../../../environments/environment';
type AOA = Array<Array<string | number>>;
// control to convert raw uploaded data to table
export class ASIControl {
  /**
  * @arg ASIColumns to store the asi constant headings
  **/
  public static ASIColumns: Array<string> = [];
  /**
  * @arg asiProduct to store an asi product
  **/
  private asiProduct: ASIProducts;
  /**
  * @arg apiRequest to store api request
  **/
  private apiRequest: Array<ASIProducts>;
  /**
  * @arg tableData to store table data
  **/
  private tableData: Array<any>;
  /**
  * @arg titles to store raw titles from the raw data
  **/
  private titles: Array<string>;
  /**
  * @arg values to store raw values from the raw data
  **/
  private values: AOA;
  /**
  * @arg capabilities to store parsed capabilities from the raw data
  **/
  private capabilities: Array<string | object> = [];
  /**
   *@arg activePortal active portal stores whether it's svpp or svppv2 or admin or dealer-admin or navi
   **/
  public activePortal: string;
  public static asiUploadGeneration: string;
  constructor(data: AOA, activePortal: string) {
    this.activePortal = activePortal;
    this.setRawData(data);
    this.apiRequest = [];
    this.convertToTable();
  }
  /**
  * @method checkColumns checks if the columns have the required fields until the column description
  * @param columns columns of the raw data
  **/
  public static checkColumns(columns: Array<string>, type?: string): boolean {
    ASIControl.asiUploadGeneration = type; 
    let validData = true;
    ASIControl.ASIColumns = window.location.pathname.includes('svppv2') ? asiColumnsV2 : asiColumns;
    columns.slice(0, 9).forEach(column => {
      if (!(ASIControl.ASIColumns.indexOf(column.trim()) > -1)) {
        validData = false;
      }
    });
    if (validData && (ASIControl.asiUploadGeneration === '21MM' || ASIControl.asiUploadGeneration === '24MM')) {
      validData = true;
      ASIControl.ASIColumns = window.location.pathname.includes('svppv2') ? productBundleV2 : asiColumns;
      columns.slice(0, 12).forEach(column => {
        if (!(ASIControl.ASIColumns.indexOf(column.trim()) > -1)) {
          validData = false;
        }
      });
    }
    return validData;
  }
  /**
   * @method setRawData sets the raw data to the model
   * @param data data to be set
   **/
  private setRawData(data: AOA): void {
    const columns = data[0] as Array<string>;
    if (ASIControl.checkColumns(columns, ASIControl.asiUploadGeneration)) {
      this.titles = columns;
      this.values = data.splice(1);
    } else {
      throwError(() => 'invalid format for the file');
    }
  }
  /**
  * @method convertToRequest converts the raw data to the api request format
  **/
  private convertToRequest(productIds?: any): void {
    for (let row = 0; row < this.values.length; row++) {
      const rowData = this.values[row];
      if(ASIControl.asiUploadGeneration === '17CYPLUS'){
        if (rowData.length === this.titles.length) {
          this.parseRow(rowData);
        }
      }
      if(ASIControl.asiUploadGeneration === '21MM' || ASIControl.asiUploadGeneration === '24MM'){
        this.parseRow(rowData, productIds);
      }
    }
  }
  /**
  * @method parseRow parses row data to asiproduct
  * @param rowData rowdata
  **/
  private parseRow(rowData: Array<string | number>, productIds?: any): void {
    this.resetProducts();
    for (let index = 0; index < rowData.length; index++) {
      this.setDetails(index, rowData[index]);
    }
    if(ASIControl.asiUploadGeneration === '17CYPLUS'){
      this.setApiRequest();
    }
    if(ASIControl.asiUploadGeneration === '21MM' || ASIControl.asiUploadGeneration === '24MM') {
      this.setApiRequest(productIds);
    }
  }
  /**
  * @method convertToTable converts the raw data to table format (only the values not the heading)
  **/
  private convertToTable(): void {
    this.tableData = [];
    for (let row = 0; row < this.values.length; row++) {
      const tableRow = {};
      const rowData = this.values[row];
      if (ASIControl.asiUploadGeneration === '17CYPLUS' && rowData.length === this.titles.length) {
        for (let index = 0; index < rowData.length; index++) {
          tableRow[this.titles[index].trim()] = rowData[index];
        }
        this.tableData.push(tableRow);
      }
      if(ASIControl.asiUploadGeneration === '21MM' || ASIControl.asiUploadGeneration === '24MM') {
        for (let index = 0; index < rowData.length; index++) {
          tableRow[this.titles[index].trim()] = rowData[index];
        }
        this.tableData.push(tableRow);
      }
    }
  }
  /**
  * @method resetProducts resets the asi product
  **/
  private resetProducts(): void {
    var clone = '';
    if(ASIControl.asiUploadGeneration === '17CYPLUS') {
      clone = JSON.stringify(initialASIProduct);
    }
    if(ASIControl.asiUploadGeneration === '21MM' || ASIControl.asiUploadGeneration === '24MM') {
       clone = JSON.stringify( ASIControl.ASIColumns !== productBundleV2 ? initialASIProduct : initialproductBundle);
    }
    const defaultAsi = JSON.parse(clone);
    this.asiProduct = defaultAsi;
    this.capabilities = [];
  }
  /**
  * @method setApiRequest sets the api request
  **/
  private setApiRequest(productIds?: any): void {
    if(ASIControl.asiUploadGeneration === '17CYPLUS') {
      this.asiProduct.capabilities = this.capabilities;
    }
    if(ASIControl.asiUploadGeneration === '21MM' || ASIControl.asiUploadGeneration === '24MM') {
      if(ASIControl.ASIColumns !== productBundleV2) {
        this.asiProduct.capabilities = this.capabilities
      }
      this.asiProduct['productIds'] = productIds['payload']['products'].filter(item => this.asiProduct['productIds'].includes(item.fnaProductCode)).map((item) => item.productID);
    }
    this.apiRequest.push(this.asiProduct);
  }
  /**
  * @method setDetails sets all the asi values from the raw data
  * @param index column index
  * @param value value to be stored
  **/
  private setDetails(index, value): void {
    const columnTitle = this.titles[index].trim();
    ASIControl.ASIColumns.indexOf(columnTitle) > -1 && columnTitle !== 'MPC' ? this.setAsiDetails(index, value) :
      columnTitle === 'MPC' ? this.setMpc(index, value) : this.setCapabilities(index, value);
    if (ASIControl.ASIColumns.indexOf(columnTitle) > -1 && columnTitle === 'Launch') {
      this.setGeneration(value);
    }
    if (ASIControl.ASIColumns.indexOf(columnTitle) > -1 && (ASIControl.asiUploadGeneration === '21MM' || ASIControl.asiUploadGeneration === '24MM') && (columnTitle === 'Trial' || columnTitle === 'Paid Bundles' || columnTitle === 'Goodwill Bundles' ||  columnTitle === 'PPO')) {
      this.setProductIds(value);
    }
  }
  /**
  * @method setGeneration sets all the generation values from the raw data
  * @param value value to be stored
  **/
  setGeneration(value) {
    this.asiProduct['generation'] = value;
  }
  /**
  * @method setAsiDetails sets the asi details (not the capabilities)
  * @param index column index
  * @param value value to be stored
  **/
  private setAsiDetails(index, value): void {
    if(!!this.getProperty(index)) { this.asiProduct[this.getProperty(index)] = !!value ? `${value}` : ''; }
  }
  /**
  * @method setProductIds sets the setProductIds property of the request from the raw data
  * @param index column index
  * @param value value to be stored
  **/
  private setProductIds(value): void {
    value = value.replace(/[\r\n|\n|\r]+/g, '').trim();
    value = value.split(/,/);
    value.forEach(product =>{
      this.asiProduct['productIds'] = !!product && [...this.asiProduct['productIds'], ...product.trim()];
    })
  }
    /**
  * @method setMpc sets the mpc property of the request from the raw data
  * @param index column index
  * @param value value to be stored
  **/
     private setMpc(index, value): void {
      this.asiProduct[this.getProperty(index)] = value.split(',');
    }
  /**
  * @method getProperty gets the property keys for the api request from the columntoProperty mapping
  * @param index column index
  **/
  private getProperty(index): string {
    if(ASIControl.asiUploadGeneration === '17CYPLUS') {
      return columnToPropertyMapping[this.titles[index].trim()];
    }
    if(ASIControl.asiUploadGeneration === '21MM' || ASIControl.asiUploadGeneration === '24MM') {
      return ASIControl.ASIColumns !== productBundleV2 ? columnToPropertyMapping[this.titles[index].trim()] : columnToproductBundleMapping[this.titles[index].trim()];
    }
  }
  /**
  * @method setCapabilities sets the capabilities from the raw data
  * @param index column index
  * @param value value to be stored
  **/
  private setCapabilities(index: number, value: string): void {
    if (this.activePortal === 'svppv2') {
      if (value === 'Y') {
        this.capabilities.push(this.titles[index]);
      }
    } else {
      const capability = {};
      capability[this.titles[index]] = !!value && value.toUpperCase().trim() === 'Y' ? true : false;
      this.capabilities.push(capability);
    }
  }
  /**
  * @method toBoolean converts the values to boolean
  * @param value to be converted
  **/
  private toBoolean(value: string): boolean {
    return value === 'Y' ? true : false;
  }
  /**
  * @method getApiRequest returns the api request
  **/
  public getApiRequest(productIds: any): Array<ASIProducts | productBundle> {
    if(ASIControl.asiUploadGeneration === '17CYPLUS') {
      this.convertToRequest();
    }
    if(ASIControl.asiUploadGeneration === '21MM' || ASIControl.asiUploadGeneration === '24MM') {
      this.convertToRequest(productIds);
    }
    return this.apiRequest;
  }
  /**
  * @method getTableData returns the table
  **/
  public getTableData(): Array<object> {
    return this.tableData;
  }
  /**
  * @method getColumns returns the column names
  **/
  public getColumns(): Array<string> {
    return this.titles;
  }
  /**
  * @method getReviewApiEndpoint returns the end point to call the approve endpoint for asi, submit endpoint for asi product mapping
  */
     public get getReviewApiEndpoint(): string {
        return environment.ProductCatalog.apis.approveAsiV2;
    }
  /**
 * @method getEndpoint get the capabilities api
 */
  public get getEndpoint() {
    return this.activePortal === 'svppv2' ? environment.ProductCatalog.apis.asiv2 : environment.ProductCatalog.apis.asi;
  }

  /**
  * @method getApitype returns api type
  * @returns object
  **/
  public get getApiType(): object {
    return { type: 'asi' };
  }

}
